import { useEffect, useRef } from 'react'

export function useNavbarScroll() {
  const navbarRef = useRef(null)

  useEffect(() => {
    const navbar = navbarRef.current
    if (!navbar) return

    const handleScroll = () => {
      if (window.scrollY > 50) {
        navbar.style.boxShadow = '0 4px 20px rgba(30, 28, 27, 0.15)'
      } else {
        navbar.style.boxShadow = '0 2px 10px rgba(30, 28, 27, 0.08)'
      }
    }

    window.addEventListener('scroll', handleScroll)
    
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return navbarRef
}
